module.exports = __webpack_public_path__ + "media/images/ninestars/portfolio/portfolio-2-95e18234b6de120e36f3d977c0f905a0.jpg";